export default __webpack_public_path__ + "static/media/contained2_left.2e2da795.svg";